import { Component, Input, OnDestroy, AfterViewInit, OnInit } from '@angular/core';
import {StreamProject, StreamChat} from "../../../interfaces";
import { SocketStreamsChat } from '../../../services/sockets'
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {SocialAuthService} from '../../../services/social-auth.service'
import {StreamsService} from '../../../services/streams.service'
 
@Component({
  selector: 'app-watcher-chat',
  templateUrl: './watcher-chat.component.html',
  styleUrls: ['./watcher-chat.component.scss']
})
export class WatcherChatComponent implements OnInit, OnDestroy, AfterViewInit {


  @Input() stream: StreamProject;
  @Input() nameFromEmbed: any = null
  public messages: any[] = [];
  user:any = {};
  chat$:any = null;
  chat:StreamChat = null;
  uid:string = '';
  userIdenity:string = '';
  emailPanel:boolean = false;
  loggined:boolean = false;
   banned:boolean = false;
   logginMode:boolean = false;
     enterByLoginError:boolean = false;
   

  constructor(
    private socket: SocketStreamsChat,
    private socialAuth: SocialAuthService,
    private streamsService : StreamsService
     ) {
      //this.socket.removeAllListeners()
     // this.socket.disconnect()
     } 


     ngOnInit(): void {

this.emailPanel = localStorage.getItem('emailLogin') ? true : false
// getChat
      this.chat$ = this.streamsService.getChatPublish(this.stream._id)
      .subscribe((chat: StreamChat)=>{
 

        this.chat = chat

        this.messages = this.chat.messages.map(message=>{


          return {
                  _id: message._id,
           id: message.id,
	   token_type:message.token_type,
	   ip: message.ip,
          uid: message.uid,
          fromOwner: message.fromOwner || false,
          socialId: message.socialUserIdentity,
            type: message.type,
            text: message.text,
            date: message.date,
            user: {
              name:  message.userInfo.name,
              avatar:  message.userInfo.avatar
            }

          }

        })

        this.socket.on('onMessage', this.onMessage.bind(this))
        this.socket.on('onEvent', this.onEvent.bind(this))

           	this.socket.on('onDelete', this.onDeleteMessage.bind(this))

           	this.socket.on('onBanUser', this.onBanUser.bind(this))
           	this.socket.on('onBanMe', this.onBanMe.bind(this))
		this.socket.on('onUnbanUser', this.onUnbanUser.bind(this))

        this.socket.on('joined', ()=>{
    
 
          if(this.socialAuth.isAuthenticated() ){

            let token = this.socialAuth.getToken()
            if(token && !this.loggined){
               
              this.socket.emit('login', {token: token})
        
            }
          } else {
		if(this.nameFromEmbed){
		  this.enterByLogin(this.nameFromEmbed)
		}

 	  }

 
        })

        // 
        
  

        this.socket.on('connect', ()=>{
                this.socket.emit('onJoin',{
                  data:this.chat._id 
                })

            })

 
        
          this.socket.connect() 
        
 
         
          })

     }


  ngAfterViewInit(): void {} 

  onMessage(message){

 
    this.messages.push(message);
  }
  

	 onDeleteMessage(id){
		this.messages = this.messages.filter(msg=> msg.id !== id)

	}

	onBanUser(socialId){

		this.messages = this.messages.filter(msg=> msg.socialId !== socialId)

		if(this.userIdenity === socialId){

		   //this.user = {}
			//    this.loggined = false
			    this.banned = true
		}
	}

	onBanMe(){
	 //  this.user = {}
	  // this.loggined = false
	   this.banned = true
		
	}

	onUnbanUser(){

	   this.banned = false
	}


  onEvent(event){
    
    if(event.type === 'loggined'){
      this.user = event.payload.user
      this.uid = event.payload.uid
     this.userIdenity = event.payload.identity
      this.emailPanel = false
      this.loggined = true
     /// this.updateReply()

     

      return
    } 

	 
    if(event.type === 'logginedBaned'){
		   this.banned = true
      this.user = event.payload.user
      this.uid = event.payload.uid
     this.userIdenity = event.payload.identity
      this.emailPanel = false
      this.loggined = true
	
     /// this.updateReply()

     

      return
    } 

    if(event.type === 'broken_token'){
      this.logout()
      return
    }
  }

  sendMessage(event: any) {
 
    if(!this.loggined){
      return
    }
    this.socket.emit('message',{
      text: event.message, 
      type: 'text',
      user: this.user  
    })

  }

  socialLoginCallBack(token){
   
  
      if(this.loginWindow){
        this.loginWindow.close()
        this.loginWindow = null
      }
 
       this.socialAuth.login(token).subscribe((data)=>{

        if(data){
          this.user = this.socialAuth.user
          let t = this.socialAuth.getToken()
          if(t){
            this.socket.emit('login', {token: t})
          }
        
        }
        
      })
 
  }

  loginByEmail(key){
  
    this.socialAuth.loginEmail(key).subscribe((data)=>{

      if(data){
        this.user = this.socialAuth.user
        let t = this.socialAuth.getToken()
        if(t){

          this.socket.emit('login', {token: t})
        }
      
      } else {
        alert('Не вдалося увійти')
        
      }
      
    })

  }

  

  enterByLogin(login){
	 let name = login.trim()

	this.enterByLoginError = false

	if(name.length < 3){
		this.enterByLoginError = true
		return
	}

	 this.socialAuth.loginByName(this.chat._id, login).subscribe((data)=>{
  
	      if(data){
		this.user = this.socialAuth.user
		let t = this.socialAuth.getToken()
		if(t){

		  this.socket.emit('login', {token: t})
		}
	      
	      } else {
		alert('Не вдалося увійти')
		
     		 }
      
    })
  }


loginWindow:any = null
  login(){
    this.loginWindow = window.open('/api/social_auth/login'
    ,"Login"
    ,`width=370,height=190,left=${(window.innerWidth / 2) - 185},top=${(window.innerHeight / 2) - 90},resizable=no,scrollbars=no,status=no`)
    this.loginWindow.onload = () => {
      this.loginWindow.socialLoginCallBack = this.socialLoginCallBack.bind(this)
    };
      
  }

  logout(){
    this.socialAuth.logout()
    this.socket.emit('logout')
    this.user = {}
    this.loggined = false
  }


  openEmailEnterPanel(){
    this.emailPanel = true
  }


  ngOnDestroy(){


    if( this.chat$ ){
      this.chat$.unsubscribe()
    }

   // this.socket.removeAllListeners()

	this.socket.disconnect()
	 
    
	 this.socket.removeAllListeners('onMessage')
 	this.socket.removeAllListeners('onEvent')
 	this.socket.removeAllListeners('onDelete')
 	this.socket.removeAllListeners('onBanUser')
 	this.socket.removeAllListeners('onBanMe')
	 this.socket.removeAllListeners('onUnbanUser')
	 this.socket.removeAllListeners('joined')
	 this.socket.removeAllListeners('connect')  /* */
    
  }

}
 
